function initCustReviewsSection(sectionId) {
  var section = document.getElementById('cust-reviews-section-' + sectionId);
  if (!section) return;

  var tabs   = section.querySelectorAll('.cust-reviews-section__tab');
  var panels = section.querySelectorAll('.cust-reviews-section__panel');

  /* ── Tab 切换 ── */
  function activateTab(index) {
    tabs.forEach(function (tab, i) {
      var isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach(function (panel, i) {
      var isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { activateTab(index); });
  });

  /* ── 评论数：MutationObserver 异步回填（Google / Stamped） ── */
  function watchReviewCount(tab, panel) {
    var nameEl = tab.querySelector('[data-tab-name]');
    if (!nameEl) return;

    var reviewType = tab.dataset.reviewType;

    function extractCount(text) {
      var m = text.match(/\d[\d,]*/);
      return m ? m[0] : null;
    }

    function trySetCount() {
      var count = null;

      if (reviewType === 'google') {
        var googleCountEl = panel.querySelector('.reputon-reviews-count');
        if (!googleCountEl) return false;
        count = extractCount(googleCountEl.textContent || '');
      } else if (reviewType === 'stamped') {
        var stampedCountEl = panel.querySelector('.stamped-tab-container [data-type="reviews"]');
        if (!stampedCountEl) return false;
        count = stampedCountEl.getAttribute('data-count') || '';
      }

      if (!count) return false;
      var baseName = nameEl.getAttribute('data-base-name') || nameEl.textContent.trim();
      nameEl.setAttribute('data-base-name', baseName);
      nameEl.textContent = baseName + ' (' + count + ' Reviews)';
      return true;
    }

    if (trySetCount()) return;

    var observer = new MutationObserver(function () {
      if (trySetCount()) observer.disconnect();
    });
    observer.observe(panel, { childList: true, subtree: true, characterData: true });
  }

  tabs.forEach(function (tab, i) {
    if (tab.dataset.reviewType === 'google' || tab.dataset.reviewType === 'stamped') {
      watchReviewCount(tab, panels[i]);
    }
  });
}
